module.exports = __webpack_public_path__ + "Projects.c58749085121e3799c567768e31fada8.hashedasset.svg";